// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import styles from './StatusTag.module.css';

const STATUS_TONE: Record<string, string> = {
  approved: 'ok',
  in_review: 'info',
  draft: 'idle',
  deprecated: 'idle',
  completed: 'ok',
  failed: 'err',
  running: 'info',
};

interface StatusTagProps {
  status: string;
}

/** Colored status pill for procedure/artifact/run status values (approved/in_review/draft/deprecated/completed/failed/running). */
export default function StatusTag({ status }: StatusTagProps) {
  if (!status) return null;
  const tone = STATUS_TONE[status] ?? 'idle';
  const label = status.replace(/_/g, ' ');
  return (
    <span className={`${styles.tag} ${styles[tone]}`}>
      {label.charAt(0).toUpperCase() + label.slice(1)}
    </span>
  );
}
